import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';
import TargetExtendedDetailsComponent from '@Components/Results/targets/target-extended-details.component';
import TargetBasicDetailsComponent from '@Components/Results/targets/target-basic-details.component';
import TargetMostActiveSubstanceComponent from '@Components/Results/targets/target-most-active-substance.component';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

export default class TargetComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      targetDetailsExpanded: false,
    };

    this.toggleTargetDetails = this.toggleTargetDetails.bind(this);
  }

  // eslint-disable-next-line react/sort-comp
  toggleTargetDetails() {
    this.setState((prevState) => {
      return {
        targetDetailsExpanded: !prevState.targetDetailsExpanded,
      };
    });
  }

  getTrackingAttrs() {
    const { context, metadata, target } = this.props;
    return {
      'data-click-delegation': 'true',
      'data-tracking': 'true',
      'data-tracking-context': context || get(metadata, 'context'),
      'data-tracking-preview': getValueByNs(this.props, 'metadata.isViewPreview'),
      ...PrepareTrackingDataHelper.prepare(target),
    };
  }

  render() {
    const { metadata, target, zoom: zoomValue } = this.props;
    const { targetDetailsExpanded } = this.state;
    const zoom = metadata.isViewPreview ? 0 : zoomValue;

    return (
      <div className="rx-element-content">
        <div className="clearfix rx-element--target__wrapper">
          <TargetBasicDetailsComponent
            metadata={metadata}
            target={target}
            detailsExpanded={targetDetailsExpanded}
            onDetailsToggle={this.toggleTargetDetails}
            trackingAttrs={this.getTrackingAttrs()}
          />
          <TargetMostActiveSubstanceComponent metadata={metadata} target={target} zoom={zoom} />
        </div>
        {targetDetailsExpanded && (
          <TargetExtendedDetailsComponent
            metadata={metadata}
            target={target}
            onDetailsToggle={this.toggleTargetDetails}
            trackingAttrs={this.getTrackingAttrs()}
          />
        )}
      </div>
    );
  }
}

TargetComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  target: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  context: PropTypes.string,
};
